/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteJobRequestInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type DeleteJobRequestMutationVariables = {|
  input: DeleteJobRequestInput
|};
export type DeleteJobRequestMutationResponse = {|
  +deleteJobRequest: ?{|
    +jobRequest: ?{|
      +dbId: number
    |},
    +errors: any,
  |}
|};
export type DeleteJobRequestMutation = {|
  variables: DeleteJobRequestMutationVariables,
  response: DeleteJobRequestMutationResponse,
|};
*/


/*
mutation DeleteJobRequestMutation(
  $input: DeleteJobRequestInput!
) {
  deleteJobRequest(input: $input) {
    jobRequest {
      dbId
      id
    }
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteJobRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteJobRequestPayload",
        "kind": "LinkedField",
        "name": "deleteJobRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobRequest",
            "kind": "LinkedField",
            "name": "jobRequest",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteJobRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteJobRequestPayload",
        "kind": "LinkedField",
        "name": "deleteJobRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobRequest",
            "kind": "LinkedField",
            "name": "jobRequest",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08be96601a357ea14b41b3520104e5c1",
    "id": null,
    "metadata": {},
    "name": "DeleteJobRequestMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteJobRequestMutation(\n  $input: DeleteJobRequestInput!\n) {\n  deleteJobRequest(input: $input) {\n    jobRequest {\n      dbId\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec2ad0ecdb1c97b3ea685ec4fb7ef0d3';

module.exports = node;
